import { Injectable } from '@angular/core';

/**
 * Single source of truth for "where does Requests live".
 *
 * V3 is now the only Requests surface for every org (SD-10346): `/app/requests` for the
 * landing dashboard, `/app/requests/submission/:id` for a submission. The per-org V3 flag
 * is retired, so these getters are constants.
 *
 * The service stays because roughly eight components resolve their Requests links through
 * it, and because the legacy V2 paths (`/app/forms`, `/app/form-submission/:id`) are still
 * live as redirects for already-sent notification emails and bookmarks — nothing in the app
 * should be building those paths by hand.
 */
@Injectable({ providedIn: 'root' })
export class RequestsRoutingService {
    /** The Requests landing page. */
    get root(): string {
        return '/app/requests';
    }

    /** A single submission's detail page. */
    submissionDetail(submissionId: number | string): string {
        return `/app/requests/submission/${submissionId}`;
    }

    /** routerLink-friendly array form of {@link root}. */
    get rootLink(): string[] {
        return [this.root];
    }

    /** routerLink-friendly array form of {@link submissionDetail}. */
    submissionDetailLink(submissionId: number | string): string[] {
        return [this.submissionDetail(submissionId)];
    }
}
